
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';

import { Operation, OperationCategory } from './operation';
import { OperationService } from './operation.service';
import { NotifierService } from '../ui';
import { SessionService } from '../session';
import { User } from '../user';

type ViewMode = 'new' | 'edit';

const CATEGORIES = [
  'Contentieux',
  'Droit fiscal',
  'Droit des sociétés',
  'Droit des Associations',
  'Droit des contrats',
  'Fusion & Acquisition',
];

@Component({
  templateUrl: './operation-edit.component.html',
})
export class OperationEditComponent implements OnInit {

  operation: Operation
  operationsCategories: OperationCategory[]

  mode: ViewMode
  title: string

  name: FormControl

  categorySelect: string

  user: User

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private operationService: OperationService,
    private notifier: NotifierService,
    private sessionService: SessionService
  ) { }

  initForm() {
    this.operationsCategories = [
      {id: '', text: '-'}, 
      ...CATEGORIES.map(cat => ({id: cat, text: cat}))
    ];

    this.name = new FormControl(this.operation.name, [
      Validators.required
    ]);

    this.name.valueChanges.subscribe((value) => {
      this.operation.name = value;
    });

    this.categorySelect =  CATEGORIES.includes(this.operation.category) ?  this.operation.category : '';
  }

  ngOnInit() {

    this.mode = this.route.routeConfig.data.mode;
    this.title = this.route.routeConfig.data.title;

    this.sessionService.currentUser.subscribe((currentUser) => this.user = currentUser);

    switch (this.mode) {
      case 'new':
        {
          this.operation = new Operation();
          this.operation.name = '';
          this.operation.category = '';

          this.initForm();
        }
        break;

      case 'edit':
        {
          // Get the data
          this.notifier.startProgress();

          this.route.data.subscribe((data) => {
            this.operation = data.operation;

            this.initForm();
            
            this.notifier.endProgress();
          });
        }
        break;
    }
  }

  categorySelectUpdated() {
    this.operation.category = this.categorySelect;
  }

  save() {
    if (!this.operation || !this.operation.valid) {
      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    switch (this.mode) {
      case 'new':
        {
          this.operationService
            .create(this.operation).pipe(
            finalize(onComplete))
            .subscribe((operation) => {
              this.operation = operation;

              this.notifier.success('Opération créée avec succès');

              // Got to edit screen
              this.router.navigate(['operations', operation.id]);
            });
        }
        break;

      case 'edit':
        {
          this.operationService
            .update(this.operation.id, this.operation).pipe(
            finalize(onComplete))
            .subscribe((operation) => {
              this.operation = operation;

              this.notifier.success('Opération enregistrée avec succès');
            });
        }
        break;
    }
  }

  cancel() {
    if (this.mode === 'edit') {
      this.router.navigate(['operations', this.operation.id]);
    }
    else {
      this.router.navigateByUrl('/operations');
    }
  }
}
